import { APIError, ClientError, useErrorHandler, useQueryClient } from 'shared-ui';
import { toast } from 'react-toastify';

import { deleteStrefa } from 'api/strefy/strefy';
import { StrefyErrorCode } from 'api/strefy/strefy.enum';
import { StrefyErrorResponse } from 'api/strefy/strefy.types';
import { QueryKeyEnum } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { useMutation } from 'hooks/useMutation/useMutation';
import { AppMessages } from 'i18n/messages';

import { DeleteZone } from './DeleteZone';
import { DeleteZoneContainerProps } from './DeleteZone.types';

export const DeleteZoneContainer = ({ zone, isModalOpen, onModalClose }: DeleteZoneContainerProps) => {
  const queryClient = useQueryClient();
  const { formatMessage } = useLocale();
  const { handleError } = useErrorHandler();

  const { mutate: onDeleteZone, isLoading } = useMutation(deleteStrefa, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeyEnum.STREFY]);
      // The cascade removed this zone's przejścia, so the monitoring summary (liczbaPrzejsc) is stale too.
      queryClient.invalidateQueries([QueryKeyEnum.MONITORING_OBECNOSCI]);
      toast.dark(formatMessage({ id: AppMessages['definitions.zones.delete.success'] }));
      onModalClose();
    },
    onError: (error: ClientError<APIError<StrefyErrorResponse>>) => {
      const code = error.response?.data.code;
      onModalClose();

      if (code === StrefyErrorCode.MONITORING_AKTYWNY) {
        queryClient.invalidateQueries([QueryKeyEnum.MONITORING_OBECNOSCI]);
        toast.dark(formatMessage({ id: AppMessages['definitions.zones.monitoringActive'] }));
        return;
      }

      if (code === StrefyErrorCode.STREFA_MA_PODSTREFY || code === StrefyErrorCode.STREFA_NIE_ISTNIEJE) {
        queryClient.invalidateQueries([QueryKeyEnum.STREFY]);
      }

      handleError({ error });
    },
  });

  return (
    <DeleteZone
      zone={zone}
      isModalOpen={isModalOpen}
      isLoading={isLoading}
      onModalClose={onModalClose}
      onSubmit={() => onDeleteZone(zone.id)}
    />
  );
};
